import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './geo-filter-constants';

export const addresses = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CLEAR_OPTIONS,
      actionTypes.SEARCH_ADDRESS_FAILURE,
      actionTypes.SEARCH_ADDRESS_REQUEST,
    )]: () => [],
    [actionTypes.SEARCH_ADDRESS_SUCCESS]: (state, { payload }) => payload.items,
  },
  [],
);

export const isLoadingAddresses = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SEARCH_ADDRESS_FAILURE,
      actionTypes.SEARCH_ADDRESS_SUCCESS,
    )]: () => false,
    [actionTypes.SEARCH_ADDRESS_REQUEST]: () => true,
  },
  false,
);

export default combineReducers({
  addresses,
  isLoadingAddresses,
});
